import { PhoneIcon } from "assets/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Pagination, SearchInput } from "ui";

import {
  ContactDetailsModal,
  ContactsTable,
  SectionCard
} from "../../components";
import { MARKETING_CONTACTS_PAGE_SIZE } from "../../constants";
import { useMarketingContactsList } from "../../hooks";

import styles from "./MarketingContacts.module.scss";

const MarketingContacts = () => {
  const { t } = useTranslation();

  const {
    contacts,
    total,
    isLoading,
    page,
    setPage,
    searchValue,
    setSearchValue
  } = useMarketingContactsList();

  const [selectedPhone, setSelectedPhone] = useState<string | null>(null);

  return (
    <div className={styles.contacts}>
      <SectionCard
        icon={<PhoneIcon />}
        title={t("Contact base")}
        subtitle={t(
          "One record per person, keyed by phone number — created automatically from WhatsApp messages, orders and app signups."
        )}
        action={
          <span className={styles.contacts__total}>
            {total} {t("contacts")}
          </span>
        }
      >
        <SearchInput
          value={searchValue}
          placeholder={t("Search by phone or name...")}
          onChange={setSearchValue}
        />

        <ContactsTable
          contacts={contacts}
          isLoading={isLoading}
          onRowClick={(contact) => setSelectedPhone(contact.phoneNumber)}
        />

        <Pagination
          currentPage={page}
          totalItems={total}
          perPage={MARKETING_CONTACTS_PAGE_SIZE}
          onChange={setPage}
        />
      </SectionCard>

      <ContactDetailsModal
        phone={selectedPhone}
        onClose={() => setSelectedPhone(null)}
      />
    </div>
  );
};

export default MarketingContacts;
